var render = function render(){var _vm=this,_c=_vm._self._c;return _c('shipblu-card',{staticClass:"p-3",staticStyle:{"min-height":"100px"},attrs:{"cardLoading":_vm.attemptsLoader}},[_c('p',{staticClass:"font-medium text-xl mb-3"},[_vm._v(_vm._s(_vm.$t('Delivery Attempts')))]),_c('delivery-attempts-line-chart',{staticClass:"w-full h-full",attrs:{"attempts":_vm.attempts}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }